import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl, intlShape } from "@ai360/core/intl";
import classNames from "classnames";
import { withUser } from "~/hocs";
import { v4 as uuid } from "uuid";

import { Menu } from "~/core";
import { messages as globalMessages } from "~/i18n-messages";
import { recsSelectors, actions as recsEventsActions } from "~/recs-events";
import { StatusCodes } from "../../../../../common/status-messages";
import { DISABLE_EXPORT_STATUSES, DISALLOW_REC_CONVERT_COPY_STATUSES } from "../../selectors";

import { DeleteConfDialog } from "../../../../../context-menus/item-delete-confirmation-dialog";

import { messages } from "../../../i18n-messages";
import * as actions from "../../actions";
import * as recListActions from "../../actions";
import * as recInfoActions from "../../../rec-info/actions";
import { models } from "~/recs-events";
import { ErrorDetailsContextMenuLabel } from "~/action-panel/components/common/error-details-dialog/error-details-dialog";
import SendRecValidation from "../../../rec-send/send-rec-john-deere";
import SendRecAgvancePlan from "../../../rec-send/send-rec-agvance";
import { getTheUserPersonalityId } from "~/login/selectors";
import { AgvanceUtils } from "~/admin/setup/customer/agvance-utils";
import { RecSummary } from "~/recs-events/recs/model";
import { UserAPI } from "@ai360/core";

export enum AgvanceType {
    BlendTicket = "BlendTicket",
    Plan = "Plan",
}

interface IContextMenuState {
    isContextMenuExpanded: boolean;
    isDeleteConfirmationOpen: boolean;
    isExportControllerModalOpen: boolean;
    showWorkPlanValidationModal: boolean;
    showAgvanceModal: boolean;
    agvanceType: AgvanceType;
}

interface IContextMenuProps {
    activateRec?: any;
    activeTab?: string;
    convertRecsToEvents?: any;
    copyRecInfo: () => void;
    deleteRec: (index, guid) => void;
    intl: intlShape.isRequired;
    itemDimIdx: [];
    objGuid: string;
    openExportControllerFileModal: () => void;
    recSummary: RecSummary;
    selectRec: () => void;
    showRecInfo: () => void;
    showErrorDetails: (error) => void;
    userRole?: UserAPI.IUserRole;
    userGuid?: string;
    personalityId?: number;
    recGeneralGuidToRecMap?: Map<string, any>;
    recIntegrationPartnerAcccess?: any[];
    onSendJohnDeereWorkPlan: (workPlan) => void;
}
class ContextMenu_ extends Component<IContextMenuProps, IContextMenuState> {
    constructor(props) {
        super(props);
        this.state = {
            isContextMenuExpanded: false,
            isDeleteConfirmationOpen: false,
            isExportControllerModalOpen: false,
            showWorkPlanValidationModal: false,
            showAgvanceModal: false,
            agvanceType: null,
        };
    }

    _getMenuItems() {
        const {
            convertRecsToEvents,
            copyRecInfo,
            openExportControllerFileModal,
            selectRec,
            showRecInfo,
            showErrorDetails,
            recGeneralGuidToRecMap,
            recSummary,
            objGuid,
            userRole,
            activateRec,
            activeTab,
        } = this.props;
        const { formatMessage } = this.props.intl;
        const menuItems = [];

        if (
            activeTab === recsEventsActions.RecEventListTabs.ACTIVE ||
            activeTab === recsEventsActions.RecEventListTabs.SELECTED
        ) {
            menuItems.push({
                key: 0,
                label: formatMessage(messages.viewEditDetails),
                action: showRecInfo,
            });
            menuItems.push({
                key: 2,
                label: formatMessage(messages.delete),
                action: () => this.setState({ isDeleteConfirmationOpen: true }),
            });

            // Removes Copy from the menu for Equation Rec as well as for Recs with disallowed statuses
            if (
                recGeneralGuidToRecMap.has(objGuid) &&
                !(
                    recGeneralGuidToRecMap.get(objGuid).recType ===
                        models.REC_TYPE_NAME_EQUATION_APPLICATION ||
                    recGeneralGuidToRecMap.get(objGuid).recType ===
                        models.REC_TYPE_NAME_EQUATION_PLANTING
                ) &&
                !DISALLOW_REC_CONVERT_COPY_STATUSES.includes(
                    recGeneralGuidToRecMap.get(objGuid).recStatuses
                )
            ) {
                menuItems.splice(1, 0, {
                    key: 1,
                    label: formatMessage(messages.copy),
                    action: copyRecInfo,
                });
            }

            if (
                this._isApplicationRec() &&
                !DISALLOW_REC_CONVERT_COPY_STATUSES.includes(
                    recGeneralGuidToRecMap.get(objGuid).recStatuses
                )
            ) {
                menuItems.push({
                    key: 3,
                    label: formatMessage(messages.convertRecToEvent),
                    action: convertRecsToEvents,
                });
            }

            if (this._isApplicationRec() && userRole.sendRecTo) {
                const allSubMenuItems = [];
                if (
                    this._userHasIntegrationPartnerAccess(
                        formatMessage(messages.agvanceBlendTicket)
                    ) &&
                    AgvanceUtils.isAgvanceConnected(this.props.personalityId)
                ) {
                    allSubMenuItems.push({
                        key: 0,
                        label: formatMessage(messages.agvanceBlendTicket),
                        disabled: recSummary?.blendTicket,
                        action: () =>
                            this.setState({
                                showAgvanceModal: true,
                                agvanceType: AgvanceType.BlendTicket,
                            }),
                    });
                }
                if (
                    this._userHasIntegrationPartnerAccess(formatMessage(messages.agvancePlan)) &&
                    AgvanceUtils.isAgvanceConnected(this.props.personalityId)
                ) {
                    allSubMenuItems.push({
                        key: 1,
                        label: formatMessage(messages.agvancePlan),
                        disabled: recSummary?.planLetter,
                        action: () =>
                            this.setState({
                                showAgvanceModal: true,
                                agvanceType: AgvanceType.Plan,
                            }),
                    });
                }
                if (
                    this._userHasIntegrationPartnerAccess(
                        formatMessage(messages.jdOperationsCenterText)
                    )
                ) {
                    allSubMenuItems.push({
                        key: 2,
                        label: formatMessage(messages.jdOperationsCenterText),
                        action: () => this.setState({ showWorkPlanValidationModal: true }),
                    });
                }
                menuItems.push({
                    key: 4,
                    label: formatMessage(messages.sendRecToText),
                    action: () => selectRec(),
                    subMenuItems: allSubMenuItems,
                });
            }

            if (userRole.exportRecs) {
                menuItems.push({
                    key: 5,
                    label: formatMessage(messages.exportControllerFile, {
                        count: 1,
                    }),
                    action: openExportControllerFileModal,
                    disabled: DISABLE_EXPORT_STATUSES.includes(
                        recGeneralGuidToRecMap.get(objGuid).recStatuses
                    ),
                });
            }
        } else {
            if (userRole.activeInactive) {
                menuItems.push({
                    key: menuItems.length + 1,
                    label: formatMessage(messages.activateRec),
                    action: () => activateRec(),
                });
            }
        }
        if (
            [
                StatusCodes.ErrorProcessingSurface,
                StatusCodes.ErrorCreatingRec,
                StatusCodes.ExportFailed,
            ].includes(recSummary.importedStatus)
        ) {
            menuItems.push({
                key: menuItems.length + 1,
                label: formatMessage(ErrorDetailsContextMenuLabel),
                action: () => showErrorDetails(recSummary),
            });
        }

        return menuItems;
    }

    _onClick(event) {
        // prevent expand/collapse of accordion item
        event.preventDefault();
    }

    onSendRecTo(evt) {
        const { recSummary, userGuid } = this.props;
        const workPlanRequest = {
            fieldGuid: recSummary.fieldGuid,
            queueJobGuid: uuid(),
            workOrder: evt.workOrder,
            instructions: evt.instructions,
            recGeneralGuid: recSummary.recGeneralGuid,
            userGuid: userGuid,
        };
        const workPlanRequestObject = {
            entities: [workPlanRequest],
        };
        this.props.onSendJohnDeereWorkPlan(workPlanRequestObject);
    }

    _isApplicationRec() {
        const { recGeneralGuidToRecMap, objGuid } = this.props;
        return (
            recGeneralGuidToRecMap.has(objGuid) &&
            (recGeneralGuidToRecMap.get(objGuid).recType ===
                models.REC_TYPE_NAME_MANUAL_APPLICATION ||
                recGeneralGuidToRecMap.get(objGuid).recType ===
                    models.REC_TYPE_NAME_EQUATION_APPLICATION)
        );
    }

    _userHasIntegrationPartnerAccess(partnerName) {
        return this.props.recIntegrationPartnerAcccess.some((x) => x.name === partnerName);
    }

    render() {
        const { itemDimIdx, objGuid, deleteRec } = this.props;
        const { isDeleteConfirmationOpen, showWorkPlanValidationModal, showAgvanceModal } =
            this.state;

        const onDelete = () => deleteRec(itemDimIdx, objGuid);
        const deleteConfDialog = !isDeleteConfirmationOpen ? null : (
            <DeleteConfDialog
                deleteConfirmationTitle={globalMessages.confirmTitle}
                deleteConfirmationMessage={messages.deleteRecConfirmation}
                onConfirmationClick={(confirmation) => {
                    const afterClose = !confirmation ? () => null : onDelete;
                    this.setState({ isDeleteConfirmationOpen: false }, afterClose);
                }}
            />
        );

        const contextMenuClassNames = classNames("context-menu", {
            expanded: this.state.isContextMenuExpanded,
        });

        const validationProps = {
            isOpen: showWorkPlanValidationModal,
            onSend: (evt) => this.onSendRecTo(evt),
            onClose: () => this.setState({ showWorkPlanValidationModal: false }),
            sendDestination: "JD Operations Center",
            isBatch: false,
        };

        return (
            <div className="context-menu-container" onClick={(event) => this._onClick(event)}>
                <Menu
                    className={contextMenuClassNames}
                    isDotMenu={true}
                    getMenuItems={() => this._getMenuItems()}
                    onExpand={() => this.setState({ isContextMenuExpanded: true })}
                    onCollapse={() => this.setState({ isContextMenuExpanded: false })}
                />
                {deleteConfDialog}
                {showWorkPlanValidationModal && <SendRecValidation {...validationProps} />}
                {showAgvanceModal && (
                    <SendRecAgvancePlan
                        agvanceType={this.state.agvanceType}
                        onClose={() =>
                            this.setState({ showAgvanceModal: false, agvanceType: null })
                        }
                        recSummary={this.props.recSummary}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { activeTab, objGuid } = ownProps;
    const isInactiveTab = activeTab === recsEventsActions.RecEventListTabs.INACTIVE;
    const recGeneralGuidToRecMap = isInactiveTab
        ? recsSelectors.getRecGeneralGuidToInactiveRecSummaryMap(state)
        : recsSelectors.getRecGeneralGuidToRecSummaryMap(state);
    const recSummary = recGeneralGuidToRecMap.get(objGuid);
    const recIntegrationPartnerAcccess = recsSelectors.getRecIntegrationPartnerAccess(state);
    const personalityId = getTheUserPersonalityId(state);
    return { personalityId, recGeneralGuidToRecMap, recSummary, recIntegrationPartnerAcccess };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const { itemDimIdx } = ownProps;
    return {
        copyRecInfo: (recSummary) => dispatch(recInfoActions.copyRecInfo(recSummary)),
        convertRecsToEvents: (recGeneralGuidToFieldGuidMap) =>
            dispatch(recListActions.setConvertRecsToEventsGuidMap(recGeneralGuidToFieldGuidMap)),
        deleteRec: () => dispatch(recListActions.deleteRecsFromDimIdxList([itemDimIdx])),
        openExportControllerFileModal: (recGeneralGuids) =>
            dispatch(recListActions.setExportRecGeneralGuidSet(recGeneralGuids)),
        showRecInfo: (recSummary) => dispatch(recInfoActions.showRecInfo(recSummary)),
        showErrorDetails: (recSummary) => dispatch(actions.showErrorDetails(recSummary)),
        activateRec: () => dispatch(actions.activateRecFromDimIdx(itemDimIdx)),
        onSendJohnDeereWorkPlan: (workPlan) => dispatch(actions.sendJohnDeereWorkPlan(workPlan)),
        selectRec: () => {
            dispatch(actions.deselectRecsFromAccordion([0]));
            dispatch(actions.selectRecsFromAccordion(itemDimIdx, itemDimIdx));
        },
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { recSummary } = stateProps;
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        copyRecInfo: () => dispatchProps.copyRecInfo(recSummary),
        convertRecsToEvents: () =>
            dispatchProps.convertRecsToEvents(
                new Map([[recSummary.recGeneralGuid, recSummary.fieldGuid]])
            ),
        openExportControllerFileModal: () =>
            dispatchProps.openExportControllerFileModal([recSummary.recGeneralGuid]),
        showRecInfo: () => dispatchProps.showRecInfo(recSummary),
    };
};

export const ContextMenu = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(injectIntl(withUser(ContextMenu_)));
